import type { ReactNode } from "react";
import { DetailsAccordionItem } from "@design-system/Accordion/DetailsAccordionItem";
import { VStack } from "@design-system/VStack/VStack";

interface TemplateTaskDependenciesSectionProps {
    children: ReactNode;
}

export const TemplateTaskDependenciesSection = ({
    children,
}: TemplateTaskDependenciesSectionProps) => (
    <DetailsAccordionItem value="dependencies" label="Dependencies">
        <VStack gap={4}>{children}</VStack>
    </DetailsAccordionItem>
);
